import { atom } from 'jotai';

/**
 * Open-state for the Send-as-email modal. Both the legacy single-recipient
 * modal and the merged Share-via-email modal subscribe to this atom so the
 * dropdown trigger and any other call sites that flip the open state work
 * regardless of which modal the dispatcher decides to render.
 *
 * Lives in its own file (rather than `./index.tsx`) so the merged modal
 * component can subscribe to it without importing the dispatcher's hook
 * dependency graph at module-load time — which broke jest module resolution
 * by chaining through `useCombinedOrganizationInfo` → store → all rematch
 * models.
 */
export const showSendAsEmailModal = atom<boolean>(false);
